import React from "react";
import PropTypes from "prop-types";

import { TimeFrames } from "../../../../components/Orders";

const TimeFramesPage = ({ order, onChange, editing }) => (
  <div className="order-tab-container">
    <TimeFrames editing={editing} order={order} onChange={onChange} />
  </div>
);

TimeFramesPage.propTypes = {
  order: PropTypes.object,
  onChange: PropTypes.func,
  editing: PropTypes.bool
};
export default TimeFramesPage;
